module.exports = __webpack_public_path__ + "img/how-it-works-2.c90441d3.webp";